import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Twentyfourththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Lavender Mist */
            --primary: #7c3aed;  /* Violet 600 */
            --secondary: #8b5cf6; /* Violet 500 */
            --bg: #f5f3ff;       /* Violet 50 */
            --card-bg: #ffffff;
            --text: #4c1d95;     /* Violet 900 */
            --text-light: #6d28d9;
        }

        body { font-family: 'Raleway', sans-serif; background: var(--bg); color: var(--text); margin: 0; }
        .wrapper { max-width: 1400px; margin: 0 auto; background: white; box-shadow: 0 0 50px rgba(124, 58, 237, 0.05); min-height: 100vh; }
        .container { max-width: 1000px; margin: 0 auto; padding: 0 40px; }
        
        .header { padding: 40px 0; text-align: center; }
        .logo { font-size: 2rem; font-weight: 300; letter-spacing: 5px; text-transform: uppercase; color: var(--primary); }
        
        .nav { display: flex; justify-content: center; gap: 40px; margin-top: 30px; font-weight: 500; }
        .nav a { color: var(--text-light); text-decoration: none; position: relative; }
        .nav a::after { content: ''; position: absolute; width: 0; height: 1px; bottom: -5px; left: 0; background: var(--primary); transition: 0.3s; }
        .nav a:hover::after { width: 100%; }
        
        .hero { background: rgba(139, 92, 246, 0.05); padding: 100px 0; text-align: center; border-radius: 100px; margin: 40px 20px; }
        .hero h1 { font-weight: 300; font-size: 3.5rem; margin-bottom: 20px; }
        
        .btn { background: var(--primary); color: white; border: none; padding: 15px 40px; border-radius: 4px; font-family: 'Raleway', sans-serif; letter-spacing: 2px; text-transform: uppercase; cursor: pointer; transition: 0.3s; }
        .btn:hover { background: var(--secondary); box-shadow: 0 10px 20px rgba(124, 58, 237, 0.2); }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 60px; margin: 80px 0; }
        .card { text-align: center; }
        .card h3 { font-weight: 600; font-size: 1.5rem; margin-bottom: 15px; }
        .card p { font-weight: 300; line-height: 1.8; color: #666; }
        
        .product-card { position: relative; overflow: hidden; background: #fafafa; }
        .product-card img { width: 100%; height: 300px; object-fit: cover; transition: 0.5s; opacity: 0.9; }
        .product-card:hover img { transform: scale(1.05); opacity: 1; }
        .product-info { padding: 20px 0; text-align: center; }
        
        .footer { background: #fafafa; padding: 60px 0; text-align: center; font-weight: 300; font-size: 0.9rem; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;600&display=swap" rel="stylesheet" />

            <div className="wrapper">
                <div className="header">
                    <div className="logo">{get_data.service_name}</div>
                    <div className="nav">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Collection</a>
                        <a href="#contact">Contact</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                    </div>
                </div>
                
                <div className="hero">
                    <div className="container">
                        <h1>Soft. Simple. Serene.</h1>
                        <p style={{fontSize: '1.1rem', marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px'}}>Elevate your lifestyle with our curated services and products, designed for peace of mind.</p>
                        <a href="#products" className="btn">Shop Now</a>
                    </div>
                </div>
                
                <div className="container">
                    <div className="grid">
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                            <div className="card" key={index}>
                                <div style={{fontSize: '3rem', color: '#ddd6fe', marginBottom: '10px'}}>
                                    {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '60px', height: '60px'}} alt=""/> : <span>•</span>}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.description}</p>
                                <div style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px'}}>
                                    <a href={`tel:${get_data.mobile}`} className="btn" style={{padding: '10px 20px', background: 'white', color: 'var(--primary)', border: '1px solid var(--primary)', fontSize: '0.8rem'}}>Call</a>
                                    <a href="#contact" className="btn" style={{padding: '10px 20px', fontSize: '0.8rem'}}>Enquiry</a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                    
                    <h2 style={{textAlign: 'center', fontWeight: 300, fontSize: '2.5rem', marginBottom: '60px'}}>Featured Products</h2>
                    <div className="grid">
                         {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="product-card" key={index}>
                                {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} alt={item.service_name}/>) : (<div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                                <div className="product-info">
                                    <h3>{item.service_name}</h3>
                                    {item.price && <div style={{color: 'var(--primary)', fontWeight: 600, marginBottom: '10px'}}>₹{item.price}</div>}
                                    <button onClick={() => addToCart(item)} className="btn" style={{padding: '10px 30px', fontSize: '0.8rem'}}>Add to Bag</button>
                                </div>
                            </div>
                         ))}
                    </div>
                </div>
                
                <div className="footer" id="contact">
                    <p>{get_data.service_name} &nbsp;|&nbsp; {get_data.business_location_name}</p>
                    <p style={{marginTop: '10px'}}>{get_data.email}</p>
                </div>
            </div>
        </>
    );
};

export default Twentyfourththeme;
